import { Component, Inject, OnDestroy } from '@angular/core';
import { OnInit } from '@angular/core';

import { config } from "../../../config/index";

import { SnackbarService } from "../shared/services/snackbar.service";
import { ChatMessengerService } from './chat-messenger.service';
import { SessionStorageService } from '../shared/services/session-storage.service';

import { Subject, EMPTY, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
    selector: 'chat-messenger',
    template: require('./chat-messenger.component.html'),
    styles: [require('./chat-messenger.component.less')],
    providers: [SnackbarService, ChatMessengerService],
    preserveWhitespaces: true
})

export class ChatMessengerComponent implements OnInit, OnDestroy {
    chatPeopleList: any = [];
    searchPeopleList: any = [];
    groupSearchPeopleList: any = [];
    display_messages_list: any = [];
    addedPeopleList: any = [];
    limitPeople: number = 20;
    limitMessages: number = 20;
    maxLimitReached: boolean = false;
    maxLimitMessagesReached: boolean = false;
    limitMessage: number = 5;
    activeChat: any = {};
    expandChatBox: boolean = false;
    expandChatMessages: boolean = false;
    expandChatSearch: boolean = false;
    expandChatSearchInput: boolean = false;
    expandNewGroup: boolean = false;
    searchInput: any;
    groupSearchInput: any;
    groupActionType: string = 'create';
    editGroupDetails: any;
    flagMsgHistory: boolean = false;
    hideChatComponent: boolean = true;
    chatHide: boolean = false;
    chatHideFlag: boolean = false;
    token: any;
    socket: WebSocket;
    url = config.socket_url;
    userDetails: any = {};
    months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    unread_count: number = 0;
    showInvitationTemplate: boolean = false;
    showInvitationMember: any;
    showNoAddButton: boolean = false;
    phoneMembers: any = [];
    groupName: any;
    currentlyExpandedWindow: any = {};
    socketErrorFlag: boolean = false;
    preventMessageScroll: boolean = false;
    dragEventFlag: boolean = false;
    roleLabels: any = {
        "COO Admin": "COO",
        "TC": "TC",
        "Location Manager": "LM"
    };
    roleColor: any = {
        "COO Admin": "#005D86",
        "TC": "#19AED1",
        "Location Manager": "green"
    };
    chatOpenFrom: any;
    chatWindowLoading: boolean = false;

    apiSubscriptions: Subscription[] = [];
    chatPeopleSubscription: Subscription;
    addMemberToGroupSubscription: Subscription;
    addPhoneToGroupSubscription: Subscription;
    removePhoneSubscription: Subscription;
    removeMemberSubscription: Subscription;
    createGroupSubscription: Subscription;
    startNewChatSubscription: Subscription;
    searchPeopleSubscription: Subscription;
    getMessagePeopleSubscription: Subscription;
    chatRoomSubscription: Subscription;
    // search subjects
    groupPeopleSearchInputSub$: Subject<string> = new Subject<string>();
    peopleSearchInputSub$: Subject<string> = new Subject<string>();

    minimiseChat(event: any) {
        event.stopPropagation();
        this.expandChatBox = false;
    }

    mouseUpEvent() {
        if (!this.dragEventFlag) {
            this.expandChatBox = !this.expandChatBox;
        }
    }

    showEmptyWindow() {
        if (this.expandChatMessages || this.expandChatSearch || this.expandNewGroup) {
            return true;
        }
        return false;
    }

    hideAll() {
        if (this.currentlyExpandedWindow['expandChatMessages']) {
            this.expandChatMessages = true;
        } else {
            this.expandChatMessages = false;
        }
        if (this.currentlyExpandedWindow['expandChatSearch']) {
            this.expandChatSearch = true;
        } else {
            this.expandChatSearch = false;
        }
    }

    constructor(
        private _chatService: ChatMessengerService,
        private _sessionStorageService: SessionStorageService,
        private _mdlSnackbarService: SnackbarService,
        @Inject('utilService') private utilService: any
    ) {
        this.utilService.hideChat.subscribe(this.changeChatHide);
        this.utilService.phoneNoChatDetails.subscribe(this.chatToCommunication);
        this.utilService.userLogout.subscribe(this.clearAllData);
        this.utilService.userProfilePicUpdated.subscribe(this.updatedProfilePic);
    }

    actionRequiredPendingCountUpdate = () => {
        this.utilService.updateActionRequiredListPendingCount.next({update: true});
    }

    clearAllData = (details: any) => {
        if (details.logOut) {
            this.chatPeopleList = [];
            this.searchPeopleList = [];
            this.groupSearchPeopleList = [];
            this.display_messages_list = [];
            this.phoneMembers = [];
            this.activeChat = {};
            this.searchInput = '';
            this.groupSearchInput = '';
            this.expandChatBox = false;
            this.expandChatMessages = false;
            this.expandChatSearch = false;
            this.expandChatSearchInput = false;
            this.expandNewGroup = false;
            this.groupActionType = 'create';
            this.flagMsgHistory = false;
            this.hideChatComponent = true;
            this.chatHide = false;
            this.chatHideFlag = false;
            this.showInvitationTemplate = false;
            this.showNoAddButton = false;
            if (this.socket) {
                this.socket.close();
                this.socketErrorFlag = true;
            }
            this.utilService.LogoutChatConfirm.next({ confirm: true })
        }
    }

    chatToCommunication = (chatDetails: any) => {
        if (!this.socketErrorFlag) {
            this.expandChatBox = true;
            let followUp_data = chatDetails.followUp_data;
            let communication_data = chatDetails.communication_data;
            let patient = this.getChatPatientData(chatDetails, communication_data);
            let opt_in_status = (communication_data.opt_in_status || communication_data.sms_opt_in_status) ? true : false;

            let user, patient_id;
            if (chatDetails.patient_relapse || chatDetails.non_start_followup) {
                user = { full_name: patient.patient_name };
                patient_id = patient.patient_id;
            } else if (chatDetails.follow_up) {
                user = { full_name: communication_data.patient_name };
                patient_id = communication_data.patient_id;
            } else {
                user = { full_name: patient.first_name + " " + patient.last_name };
                patient_id = patient.id;
            }

            const chatData = {
                id: patient_id,
                room_id: followUp_data.room_id,
                full_name: user.full_name,
                plan_id: communication_data.id,
                patient_communication_enabled: opt_in_status,
                rp_id: communication_data.rp_data.id,
                rp_type: communication_data.rp_data.type,
            };

            this.startChat(chatData, followUp_data.text);
            // this.activeChat.currentMessage = followUp_data.text
        } else {
            this.expandChatBox = true;
            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
        }
    }

    getChatPatientData = (chatDetails: any, communication_data: any) => {
        let patient;

        if (chatDetails.follow_up) {
            patient = communication_data.patient;
            this.chatOpenFrom = 'follow_up';
        } else if (chatDetails.from_referral) {
            patient = communication_data.user;
            this.chatOpenFrom = 'patient_referral';
        } else if (chatDetails.parent_relapse) {
            patient = communication_data.patient;
            this.chatOpenFrom = 'parent_relapse';
        } else if (chatDetails.patient_relapse) {
            patient = communication_data;
            this.chatOpenFrom = 'patient_relapse';
        } else if (chatDetails.vc_follow_up) {
            patient = communication_data.patient;
            this.chatOpenFrom = 'vc_follow_up';
        } else if (chatDetails.non_start_followup){
            patient = communication_data;
            this.chatOpenFrom = 'non_start_followup';
        }

        return patient
    }

    changeChatHide = (settings: any) => {
        if (this.hideChatComponent === true && settings.hide === false) {
            this.chatHide = true;
        }
        this.hideChatComponent = settings.hide;
        if (this.chatHide) {
            this.initialise();
            this.chatHide = false;
        }
        this.chatHideFlag = true;
    }

    readActiveChat() {
        if (this.activeChat.unread) {
            let reqData: any = {};
            reqData['room_id'] = this.activeChat.id;
            reqData['message_type'] = 'chat.seen';
            this.socket.send(JSON.stringify(reqData));
        }
    }

    spliceExistingChat(messageRoom: any) {
        if (messageRoom) {
            let existingChatIndex = this.chatPeopleList.indexOf(messageRoom);
            if (existingChatIndex !== undefined && existingChatIndex !== null) {
                this.chatPeopleList.splice(existingChatIndex, 1);
            }
        }
    }

    updateUnreadCount(data: any, messageRoomUnread: any, addMessageRoomUnread?: boolean) {
        if (data.member && (data.member.user_id !== this.userDetails.id)
            || (data.user && (data.user.id !== this.userDetails.id))) {
            if (messageRoomUnread === 0 || (!addMessageRoomUnread && messageRoomUnread !== 0)) {
                ++this.unread_count;
            }

            if (addMessageRoomUnread) {
                ++messageRoomUnread;
            }
        }

        return addMessageRoomUnread ? messageRoomUnread : null;
    }

    updateUnreadCountForChatActions(data: any, messageRoomUnread: any) {
        if (data.member?.user_id && (data.member.user_id !== this.userDetails.id)
            || (data.user && (data.user.id !== this.userDetails.id))) {
            if (messageRoomUnread !== 0 || (['rejected', 'accepted', 'invite'].indexOf(data.message_type) !== -1 && messageRoomUnread === 0)) {
                ++this.unread_count;
            }

            if (data.message_type === 'join' || (['rejected', 'accepted', 'invite'].indexOf(data.message_type) !== -1 && messageRoomUnread === 0)) {
                ++messageRoomUnread;
            }
        }

        return messageRoomUnread;
    }

    updatePhoneIcon(data: any) {
        let userPhoneStatusList = Array.from(document.querySelectorAll('#phone' + data.member?.user_id));
        userPhoneStatusList.forEach((userPhoneStatus: any) => {
            if (userPhoneStatus) {
                if (userPhoneStatus.classList.contains('phone-icon-grey')) {
                    userPhoneStatus.classList.remove('phone-icon-grey');
                }

                if (data.message_type === 'accepted' && userPhoneStatus.classList.contains('phone-icon-red')) {
                    userPhoneStatus.classList.remove('phone-icon-red');
                }

                data.message_type === 'accepted' ? userPhoneStatus.classList.add('phone-icon-green') : userPhoneStatus.classList.add('phone-icon-red');
            }
        });
    }

    onMessageOrImage(data: any) {
        let messageRoom = this.chatPeopleList.find((member: any) => member.id === data.room);
        if (messageRoom) {
            messageRoom.unread = this.updateUnreadCount(data, messageRoom.unread, true);

            let duplicateMessage = messageRoom.messages_list.filter((message: any) => message.id === data.id);
            if (duplicateMessage.length === 0) {
                messageRoom.messages_list = [data].concat(messageRoom.messages_list);
            }

            if (messageRoom.id === this.activeChat.id) {
                this.setDisplayMessages(messageRoom.messages_list);
            }

            this.spliceExistingChat(messageRoom);
            this.chatPeopleList.unshift(messageRoom);
            this.scrollMessageDivBottom()
        } else {
            this._chatService.getMessageRoomDetails(data.room)
                .subscribe((res: any) => {
                    this.updateUnreadCount(data, res.data.unread);

                    let messageRoom = this.chatPeopleList.find((member: any) => member.id === data.room);
                    this.spliceExistingChat(messageRoom);
                    this.chatPeopleList.unshift(res.data);
                }, error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
        }
    }

    onChatActions(data: any) {
        let messageRoom = this.chatPeopleList.find((member: any) => member.id === data.room);
        if (messageRoom) {
            this.onChatActionsExisting(data, messageRoom);
        } else {
            this._chatService.getMessageRoomDetails(data.room)
                .subscribe((res: any) => {
                    this.updateUnreadCount(data, res.data.unread);

                    let messageRoom = this.chatPeopleList.find((member: any) => member.id === data.room);
                    this.spliceExistingChat(messageRoom)
                    this.chatPeopleList.unshift(res.data);
                }, error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
        }
    }

    onChatActionsExisting(data: any, messageRoom: any) {
        if (['accepted', 'rejected'].indexOf(data.message_type) !== -1) {
            messageRoom.approval = data.message_type;
            this.updatePhoneIcon(data);
        }

        messageRoom.unread = this.updateUnreadCountForChatActions(data, messageRoom.unread);

        if (data.message_type === 'join') {
            messageRoom.messages_list = [data].concat(messageRoom.messages_list);
            if (messageRoom.id === this.activeChat.id) {
                this.setDisplayMessages(messageRoom.messages_list);
            }
        }

        this.spliceExistingChat(messageRoom);
        this.chatPeopleList.unshift(messageRoom);

        if (messageRoom.id === this.activeChat.id) {
            this.activeChat = messageRoom;
            if (data.message_type === 'accepted') {
                this.fetchMessages(messageRoom, true);
            }
        }
    }

    onLeaveChat(data: any) {
        let messageRoom = this.chatPeopleList.find((member: any) => member.id === data.room);
        if (messageRoom) {
            this.onLeaveChatExisting(data, messageRoom);
        } else if ((data.member?.user_id && (data.member.user_id === this.userDetails.id))
                || data.user && (data.user.id === this.userDetails.id)) {
            this._chatService.getMessageRoomDetails(data.room)
                .subscribe((res: any) => {
                    this.updateUnreadCount(data, res.data.unread);

                    let messageRoom = this.chatPeopleList.find((member: any) => member.id === data.room);
                    this.spliceExistingChat(messageRoom);
                    this.chatPeopleList.unshift(res.data);
                }, error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
        }
    }

    onLeaveChatExisting(data: any, messageRoom: any) {
        this.spliceExistingChat(messageRoom);

        if (data.removed_user?.id !== this.userDetails.id) {
            messageRoom.unread = this.updateUnreadCount(data, messageRoom.unread, true);

            messageRoom.messages_list = [data].concat(messageRoom.messages_list);
            if (messageRoom.id === this.activeChat.id) {
                this.setDisplayMessages(messageRoom.messages_list);
            }
            this.chatPeopleList.unshift(messageRoom);
        } else {
            if (messageRoom.id === this.activeChat.id) {
                this.hideAll();
            }
        }
    }

    onFollowUpTrigger() {
        switch(this.chatOpenFrom) {
            case 'follow_up':
                this.utilService.callFollowUpAPI.next({callAPI: true});
                break;

            case 'patient_referral':
                this.utilService.callReferralPatientAPI.next({callAPI: true});
                break;

            case 'parent_relapse':
                this.utilService.callParentRelapseAPI.next({callAPI: true});
                break;

            case 'patient_relapse':
                this.utilService.callPatientRelapseAPI.next({callAPI: true});
                break;

            case 'vc_follow_up':
                this.utilService.callVcFollowUpAPI.next({callAPI: true});
                break;

            case 'non_start_followup':
                this.utilService.callNonStartFollowupAPI.next({callAPI: true});
                break;
        }
    }

    socketInitialization(token: string) {
        this.socket = new WebSocket(this.url + token);
        this.socket.onopen = e => {
            this.socketErrorFlag = false;
        };
        this.socket.onclose = (evt: any) => {
            if (this.socket) {
                this.socket.close();
            }
            this.socketErrorFlag = true;
        };
        this.socket.onmessage = (evt: any) => {
            let data = JSON.parse(evt.data);
            if (data.room) {
                data.room = parseInt(data.room);
            }
            this.preventMessageScroll = true;
            let self = this;

            switch(data.message_type) {
                case 'message':
                case 'image':
                    this.onMessageOrImage(data);
                    break;

                case 'chat.seen':
                    let messageRoom = self.chatPeopleList.find((member: any) => member.id === data.room_id);
                    messageRoom.unread = 0;
                    self.unread_count = data.unread_room_count;
                    break;

                case 'connect':
                    self.unread_count = data.unread_room_count;
                    break;

                case 'invite':
                case 'create_group':
                case 'join':
                case 'accepted':
                case 'rejected':
                    this.onChatActions(data);
                    break;

                case 'left':
                    this.onLeaveChat(data);
                    break;

                case 'followup_trigger':
                    this.onFollowUpTrigger();
                    break;
            }
        };
        this.socket.onerror = (evt: any) => {
            if (this.socket) {
                this.socket.close();
            }
            this.socketErrorFlag = true;
        };
        // setTimeout(() => {
        //   this.timeout();
        // }, 110000);
    }

    socketReconnect() {
        this.socketErrorFlag = false;
        this.initialise();
    }
    
    updatedProfilePic = (data: any) => {
        if (data.profilePictureChange) {
            this._sessionStorageService.readItem(config.role).then(
                (data: any) => {
                    this.userDetails = data;
                }
            );
        }
    }

    initialise() {        
        if (!this.hideChatComponent) {
            this._sessionStorageService.readItem(config.role).then(
                (data: any) => {
                    this.userDetails = data;
                    if (this.userDetails.is_ses_email_verified && this.checkifAccountRestricted()) {
                        this._sessionStorageService.readItem(config.storage_key).then(
                            (tokenData: any) => {
                                if (tokenData) {
                                    this.getPeopleList();
                                    this.token = tokenData.token;
                                    this.socketInitialization(this.token);
                                }
                            });
                    } else {
                        this.hideChatComponent = true;
                    }
                });
        }
    }

    checkifAccountRestricted() {
        if (this.userDetails.subscription_status
            && (this.userDetails.subscription_status !== 'expired'
                && this.userDetails.subscription_status !== 'initial_pending'
                && (!this.userDetails.pending_payment
                    || this.userDetails.pending_payment?.type !== 'restrict'))) {
                    return true;
                }
        return false;
    }

    print(message: any) {
        console.log(message);
    }

    getPeopleList() {
        this.chatPeopleSubscription?.unsubscribe();
        this.chatPeopleSubscription = this._chatService.getChatPeople(this.chatPeopleList.length, this.limitPeople)
            .subscribe((res: any) => {
                if (res.data.length === 0) {
                    this.maxLimitReached = true;
                }
                let chatPeopleRoomIds = this.chatPeopleList.map((room: any) => room.id)
                let roomList = res.data.filter((room: any) => chatPeopleRoomIds.indexOf(room.id) === -1);
                this.chatPeopleList = this.chatPeopleList.concat(roomList);
            }, error => {
                if (error.message !== 'SUBSCRIPTION_REQUIRED' && error.detail !== 'Invalid token.' && error.detail !== 'Authentication credentials were not provided.')
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            });
    }

    ngOnInit() {
        this.initialise();

        this.apiSubscriptions.push(this.groupPeopleSearchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.groupSearchPeople(event);
                return EMPTY;
            })
            ).subscribe()
        );

        this.apiSubscriptions.push(this.peopleSearchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.searchPeople();
                return EMPTY;
            })
            ).subscribe()
        );

    }

    loadPeopleOnScroll() {
        if (!this.maxLimitReached) {
            this.getPeopleList();
        }
    }

    loadMessagesOnScroll() {
        if (!this.preventMessageScroll) {
            if (!this.maxLimitMessagesReached && !this.showInvitationTemplate) {
                this.fetchMessages(this.editGroupDetails);
            }
        } else {
            this.preventMessageScroll = false;
        }
    }

    fetchMessages(people: any, keepUnreadMessages?: any) {
        if (people) {
            this.groupSearchInput = '';
            if (this.showInvitationTemplate) {
                this.showInvitationTemplate = false;
            }
            if (this.editGroupDetails && people.id !== this.editGroupDetails.id) {
                this.flagMsgHistory = false;
                this.maxLimitMessagesReached = false;
            }
            this.editGroupDetails = people;
            this.showChatMessages();
            let self = this;
            this.getMessagePeopleSubscription?.unsubscribe();
            this.getMessagePeopleSubscription = this._chatService.getMessagePeople(people.id, people.messages_list.length, this.limitMessages)
                .subscribe(res => {
                    self.setMessages(people, res.data, keepUnreadMessages)
                });
        }
    }

    setMessages = (people: any, message_list: any, keepUnreadMessages?: any) => {
        if (!keepUnreadMessages) {
            let reqData: any = {};
            reqData['room_id'] = people.id;
            reqData['message_type'] = 'chat.seen';
            this.socket.send(JSON.stringify(reqData));
        }

        if (message_list.length === 0) {
            this.maxLimitMessagesReached = true;
        }

        people.messages_list = people.messages_list.concat(message_list);
        this.display_messages_list = JSON.parse(JSON.stringify(people.messages_list));
        this.display_messages_list = Array.from(new Set(this.display_messages_list.map((message: any) => message.id)))
            .map(id => {
            return this.display_messages_list.find((message: any) => message.id === id)
            })
        this.display_messages_list = this.display_messages_list.reverse();
        this.display_messages_list.forEach((element: any) => {
            if (element.message) {
                element.message = element.message.replace(/\n/g, "<br>");
            }
        });
        this.activeChat = people;

        if (!this.flagMsgHistory) {
            this.scrollMessageDivBottom()
        }
    }

    searchPeople() {
        if (this.searchInput && this.searchInput !== '') {
            this.showChatSearch();
        }
        this.searchPeopleSubscription?.unsubscribe();
        this.searchPeopleSubscription = this._chatService.searchChatPeople(this.searchInput)
            .subscribe((res: any) => {
                this.searchPeopleList = res.data;
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            });
    }

    isNumber(code: number) {
        return (code >= 48 && code <= 57) || (code >= 96 && code <= 105);
    }

    groupSearchPeople(e: any) {
        if (!this.hideChatComponent) {
            let code = (e.keyCode ? e.keyCode : e.which);
            if (this.groupSearchInput.length === 1 && this.isNumber(code)) {
                this.groupSearchInput = '+' + this.groupSearchInput[0];
            }
            if (this.groupSearchInput && (this.groupSearchInput[0] === '+' && this.groupSearchInput.length > 8 && this.groupSearchInput.length < 15)
                && (this.isNumber(code) || code === 187 || code === 8)) {
                this.showNoAddButton = true;
            } else {
                this.showNoAddButton = false;
            }
            if (this.groupSearchInput && this.groupSearchInput !== '') {
                this.showChatGroup();
            }
            this.searchPeopleSubscription?.unsubscribe();
            this.searchPeopleSubscription = this._chatService.searchChatPeople(this.groupSearchInput)
                .subscribe(res => {
                    this.groupSearchPeopleList = res.data;
                }, error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
        }
    }

    addPhoneNoToGroup() {
        if(this.addedPeopleList.length<5){
            this.phoneMembers.push(this.groupSearchInput);
            this.showNoAddButton = false;
            this.groupSearchInput = '';
        } else {
            this._mdlSnackbarService.showSnackbar('MAXIMUM_LIMIT_REACHED', 'error');
        }
    }

    addPhoneNoToManageGroup() {
        if(this.addedPeopleList.length<5){
            let reqData = { contact_number: this.groupSearchInput };
            this.showNoAddButton = false;
            this.groupSearchInput = '';
            this.addPhoneToGroupSubscription?.unsubscribe();
            this.addPhoneToGroupSubscription = this._chatService.addPhoneNoToGroup(this.editGroupDetails.id, reqData)
                .subscribe((res: any) => {
                    this.phoneMembers.push(res);
                    this.editGroupDetails.phone_members.push(res);
                }, error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
        } else {
            this._mdlSnackbarService.showSnackbar('MAXIMUM_LIMIT_REACHED', 'error');
        }
    }

    rejectInvitation() {
        let reqData = { approval: false };
        this.chatWindowLoading = true;
        this.apiSubscriptions.push(this._chatService.acceptInvitation(this.activeChat.id, reqData)
            .subscribe(res => {
                    this.chatWindowLoading = false;
                },
                error => {
                    this.chatWindowLoading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
        );
    }

    acceptInvitation() {
        let reqData = { approval: true };
        this.chatWindowLoading = true;
        this.apiSubscriptions.push(this._chatService.acceptInvitation(this.activeChat.id, reqData)
            .subscribe(res => {
                        this.chatWindowLoading = false;
                    },
                    error => {
                        this.chatWindowLoading = false;
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    })
        );
    }

    showSendInvitationView(filteredPeople: any, fromFollowUpText: any, communication_enabled: boolean) {
        this.showChatMessages();
        this.showInvitationMember = filteredPeople;
        this.showInvitationMember['message'] = fromFollowUpText;
        this.showInvitationMember['plan_id'] = filteredPeople.plan_id;
        if (!communication_enabled && filteredPeople.invitation_status !== 'approved' && filteredPeople.invitation_status !== 'rejected') {
            this.showInvitationTemplate = true;
        } else {
            this.sendInvitation();
        }

    }

    sendInvitation() {
        let self = this;
        let reqData = {
            member: [
                {
                'user_id': this.showInvitationMember.id,
                'rp_id': this.showInvitationMember.rp_id,
                'rp_type': this.showInvitationMember.rp_type
                }
            ]
        };
        if (this.showInvitationMember['message']) {
            reqData['message'] = this.showInvitationMember['message'];
        }
        if (this.showInvitationMember['plan_id']) {
            reqData['entry_id'] = this.showInvitationMember['plan_id'];
        }
        this.startNewChatSubscription?.unsubscribe();
        this.startNewChatSubscription = this._chatService.startNewChat(reqData, this.chatOpenFrom)
            .subscribe((res: any) => {
                this.showInvitationTemplate = false;
                this.showChatMessages();
                let data = res.data;
                switch (data.approval) {
                    case 'accepted':
                        this._mdlSnackbarService.showSnackbar('ROOM_CREATED', 'success');
                        break;
                    case 'rejected':
                        break;
                    default:
                        this._mdlSnackbarService.showSnackbar('INVITATION_SENT', 'success');
                        break;
                }
                this.setMessageRoom(data);
                this.setDisplayMessages(self.activeChat.messages_list);
                this.actionRequiredPendingCountUpdate();
                this.chatOpenFrom = '';
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            })

    }

    startChat(filteredPeople: any, fromFollowUpText?: string) {
        this.searchInput = '';
        if (filteredPeople.room_id === undefined || filteredPeople.room_id === null) {
            this.showSendInvitationView(filteredPeople, fromFollowUpText, filteredPeople.patient_communication_enabled);
            return;
        }
        let currentChat = this.chatPeopleList.find((people: any) => people.id === filteredPeople.room_id)
        if (currentChat) {
            this.startChatExistingRoom(filteredPeople, currentChat, fromFollowUpText);
        } else {
            this.startChatNewRoom(filteredPeople, fromFollowUpText);
        }
    }

    startChatExistingRoom(filteredPeople: any, currentChat: any, fromFollowUpText?: string) {
        this.activeChat = currentChat;
        this.fetchMessages(this.activeChat);
        this.showChatMessages();
        let activeChatIndex = this.chatPeopleList.indexOf(currentChat);
        if (activeChatIndex !== undefined && activeChatIndex !== null) {
            this.chatPeopleList.splice(activeChatIndex, 1);
        }
        this.chatPeopleList.unshift(currentChat);
        if (fromFollowUpText) {
            this.activeChat['resend_invitation_plan_id'] = filteredPeople.plan_id;
            this.activeChat['resend_invitation_message'] = fromFollowUpText;
            this.activeChat.currentMessage = fromFollowUpText;
            this.activeChat.plan_id = filteredPeople.plan_id;
            this.sendMessage({keyCode: 13});
        }
    }

    startChatNewRoom(filteredPeople: any, fromFollowUpText?: string) {
        let self = this;
        this.chatRoomSubscription?.unsubscribe();
        this.chatRoomSubscription = this._chatService.getMessageRoomDetails(filteredPeople.room_id)
            .subscribe((res: any) => {
                this.showChatMessages();
                let data = res.data;
                this.setMessageRoom(data);
                if (fromFollowUpText) {
                    this.activeChat['resend_invitation_plan_id'] = filteredPeople.plan_id;
                    this.activeChat['resend_invitation_message'] = fromFollowUpText;
                    this.activeChat.currentMessage = fromFollowUpText;
                    this.activeChat.plan_id = filteredPeople.plan_id;
                    this.sendMessage({keyCode: 13});
                }
                this.setDisplayMessages(self.activeChat.messages_list);
            });
    }

    showAddGroup() {
        this.groupActionType = 'create';
        this.addedPeopleList = [];
        this.phoneMembers = [];
        this.showChatGroup();
    }

    addPeopleToGroup(people: any) {
        if (this.addedPeopleList.length < 5) {
            const alreadyExisting = this.addedPeopleList.find((member: any) => {
                if (member.user_id) {
                    if (member.user_id === people.id && member.rp_id === people.rp_id && member.rp_type === people.rp_type) {
                        return member;
                    }
                } else if (member.id === people.id && member.rp_id === people.rp_id && member.rp_type === people.rp_type) {
                    return member;
                }
            });
            if (!alreadyExisting) {
                this.addedPeopleList.push(people);
            }
        } else {
            this._mdlSnackbarService.showSnackbar('MAXIMUM_LIMIT_REACHED', 'error');
        }
    }

    removePeopleFromGroup(index: any) {
        this.addedPeopleList.splice(index, 1);
    }

    removePhoneNoFromGroup(index: any) {
        this.phoneMembers.splice(index, 1);
    }

    setMessageRoom(data: any) {
        let messageRoom = this.chatPeopleList.find((member: any) => member.id === data.room);
        if (messageRoom) {
            let activeChatIndex = this.chatPeopleList.indexOf(messageRoom);
            if (activeChatIndex !== undefined && activeChatIndex !== null) {
                this.chatPeopleList.splice(activeChatIndex, 1);
            }
            this.chatPeopleList.unshift(messageRoom);
            this.activeChat = messageRoom;
            this.scrollMessageDivBottom();
        } else {
            this.chatPeopleList.unshift(data);
            this.activeChat = data;
        }
    }

    setDisplayMessages(messalge_list: any) {
        this.display_messages_list = JSON.parse(JSON.stringify(messalge_list));
        this.display_messages_list = this.display_messages_list.reverse();
        this.display_messages_list.forEach((element: any) => {
            if (element.message) {
                element.message = element.message.replace(/\n/g, "<br>");
            }
        });
    }

    createGoup() {
        let requestData;
        let memberList: any = [];
        this.addedPeopleList.forEach((element: any) => {
            const memberDetails = {
                'user_id': element.user_id ? element.user_id : element.id,
                'rp_id': element.rp_id,
                'rp_type': element.rp_type
            };
            memberList.push(memberDetails);
        });
        if (!this.groupName || this.groupName === '') {
            this._mdlSnackbarService.showSnackbar('ADD_GROUP_NAME', 'error');
        } else if (memberList.length === 0 && this.phoneMembers.length === 0) {
            this._mdlSnackbarService.showSnackbar('ADD_ATLEAST_ONE_MEMBER', 'error');
        } else {
            requestData = { member: memberList, phone_number_list: this.phoneMembers, name: this.groupName };
            let self = this;
            this.createGroupSubscription?.unsubscribe();
            this.createGroupSubscription = this._chatService.createGroup(requestData)
                .subscribe((res: any) => {
                    this.groupName = '';
                    this.groupSearchInput = '';
                    this.showChatMessages();
                    let data = res.data;
                    this.setMessageRoom(data);
                    this.setDisplayMessages(self.activeChat.messages_list);
                    this._mdlSnackbarService.showSnackbar('Group created', 'success');
                }, error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
        }
    }

    addNewGroupFromChat(member: any) {
        if (member.member_list.length) {
            this.addedPeopleList = [];
            this.groupActionType = 'create';
            this.addedPeopleList.push(member.member_list[0]);
            this.showChatGroup()
        }
    }

    manageGroup(currentGroupChat: any) {
        this.groupActionType = 'edit';
        this.editGroupDetails = currentGroupChat;
        this.addedPeopleList = [];
        this.phoneMembers = [];
        currentGroupChat.member_list?.forEach((element: any) => {
            this.addedPeopleList.push(element);
        });
        currentGroupChat.phone_members.forEach((element: any) => {
            this.phoneMembers.push(element);
        });
        this.showChatGroup();
    }

    removeExistingMemberFromGroup(member: any, index: any) {
        const requestData = {
            'member_id': member.id
        };
        this.removeMemberSubscription?.unsubscribe();
        this.removeMemberSubscription = this._chatService.removeMember(this.editGroupDetails.id, requestData)
            .subscribe((res: any) => {
                this.addedPeopleList.splice(index, 1);
                this.editGroupDetails.member_list?.splice(index, 1);
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            });
    }

    removeExistingPhoneNoFromGroup(phone: any, index: any) {
        this.removePhoneSubscription?.unsubscribe();
        this.removePhoneSubscription = this._chatService.removePhoneNo(this.editGroupDetails.id, phone.id)
            .subscribe((res: any) => {
                this.phoneMembers.splice(index, 1);
                this.editGroupDetails.phone_members.splice(index, 1);
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            });
    }

    addPeopleToManageGroup(people: any) {
        if (this.addedPeopleList.length < 5) {
            this.addMemberToGroupSubscription?.unsubscribe();
            const requestData = {
                'user_id': people.id,
                'rp_id': people.rp_id,
                'rp_type': people.rp_type
            };
            this.addMemberToGroupSubscription = this._chatService.addMemberToGroup(this.editGroupDetails.id, requestData)
                .subscribe((res: any) => {
                    this.addedPeopleList.push(res.data);
                    this.editGroupDetails.member_list.push(res.data);
                }, error => {
                    if (error.error_code === 380) {
                        this._mdlSnackbarService.showSnackbar('ALREADY_GROUP_MEMBER', 'error');
                    } else {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    }
                });
        } else {
            this._mdlSnackbarService.showSnackbar('MAXIMUM_LIMIT_REACHED', 'error');
        }
    }

    sendMessage(e: any) {
        this.autosize();
        let code = (e.keyCode ? e.keyCode : e.which);
        let trimmedValue = this.activeChat.currentMessage ? this.activeChat.currentMessage.trim() : '';
        if (code === 13 && this.activeChat && this.activeChat.id && trimmedValue !== '' && this.activeChat.currentMessage !== undefined && this.activeChat.currentMessage !== '' && this.activeChat.currentMessage !== '\n') { //Enter keycode
            this.setMessageDataAndSend();
        }
        if (code === 13) {
            if (trimmedValue === '') {
                this.activeChat.currentMessage = '';
            }
            return false;
        }
    }

    setMessageDataAndSend() {
        let reqData = {
            room_id: this.activeChat.id, message_type: 'message',
            message: this.activeChat.currentMessage,
        };
        if (this.activeChat.plan_id) {
            reqData['followup_item_id'] = this.activeChat.plan_id;
            if (this.chatOpenFrom === 'follow_up') {
                reqData['followup_type'] = 'consultation_followup';
            } else if (this.chatOpenFrom === 'patient_referral') {
                reqData['followup_type'] = 'patient_referral_followup';
            } else if (this.chatOpenFrom === 'parent_relapse') {
                reqData['followup_type'] = 'parent_ortho_followup';
            } else if (this.chatOpenFrom === 'patient_relapse') {
                reqData['followup_type'] = 'patient_ortho_followup';
            } else if (this.chatOpenFrom === 'vc_follow_up') {
                reqData['followup_type'] = 'virtual_consultation_followup';
            } else if (this.chatOpenFrom === 'non_start_followup') {
                reqData['followup_type'] = 'non_start_tracking_followup';
            }
            this.activeChat.plan_id = null;
        }
        this.activeChat.currentMessage = '';
        if (this.socket) {
            this.socket.send(JSON.stringify(reqData));
            setTimeout(() => {
                this.chatOpenFrom = '';
                this.actionRequiredPendingCountUpdate();
            }, 1000);
        }
    }

    messageTime(dateStamp: any) {
        let msgdate = new Date(dateStamp);
        let timeString;
        let hours = msgdate.getHours();
        if (hours / 12 < 1) {
            timeString = 'AM';
            if (hours % 12 === 0) {
                hours = 12;
            }
        } else {
            timeString = 'PM';
            hours = hours - 12;
        }
        return ('0' + hours).slice(-2) + ":" + ('0' + msgdate.getMinutes()).slice(-2) + " " + timeString;
    }

    messageDate(dateStamp: any) {
        let msgdate = new Date(dateStamp);
        return msgdate.getDate() + " " + this.months[msgdate.getMonth()] + " " + msgdate.getFullYear();
    }

    showMonthLine(display_list: any, index: any) {
        if (index > 0) {
            let currentChatMonth = new Date(display_list[index].created_at);
            let previousChatMonth = new Date(display_list[index - 1].created_at);
            if (currentChatMonth.getDate() !== previousChatMonth.getDate()) {
                return true;
            }
            return false;
        }
        return true;
    }

    showTime(display_list: any, index: any) {
        if (index > 0) {
            let currentChatMonth = new Date(display_list[index].created_at);
            let previousChatMonth = new Date(display_list[index - 1].created_at);
            if (['message', 'image'].indexOf(display_list[index - 1].message_type) === -1) {
                return true;
            }
            if (this.checkSameUser(display_list, index)) {
                return true;
            }
            if (currentChatMonth.getMinutes() !== previousChatMonth.getMinutes()) {
                return true;
            }
            return false;
        }
        return true;
    }

    checkSameUser(display_list: any, index: any) {
        if (display_list[index].member && display_list[index - 1].member) {
            if (display_list[index].member.id !== display_list[index - 1].member.id) {
                return true;
            }
        } else if (!display_list[index].member && !display_list[index - 1].member) {
            if (display_list[index].phone_member.contact_number !== display_list[index - 1].phone_member.contact_number) {
                return true;
            }
        }
        return false;
    }

    sendImage() {
        document.getElementById('chat-image-file-upload').click();
    }

    changeListener($event: any): void {
        var inputValue = $event.target;
        var file: File = inputValue.files[0];
        var myReader: FileReader = new FileReader();
        var that = this;
        myReader.onloadend = (e) => {
            that.setCurrentMediaFile(file);
            let formData: any;
            formData = new FormData();
            formData.append('image', file);
            formData.append('type', 'image');
            this.chatWindowLoading = true;
            this.apiSubscriptions.push(this._chatService.uploadPhoto(formData, this.activeChat.id)
                .subscribe(res => {
                        this.chatWindowLoading = false;
                    },
                    error => {
                        this.chatWindowLoading = false;
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    }));
        }
        myReader.readAsDataURL(file);
    }

    setCurrentMediaFile(file: any) {
        // this.image_files.push(file);
    }

    alreadyAddedToGroup(people: any) {
        if (this.addedPeopleList.indexOf(people) !== -1) {
            return true;
        }
        return false;
    }

    showChatMessages() {
        this.currentlyExpandedWindow['expandChatMessages'] = false;
        this.expandChatMessages = true;
        if (this.expandNewGroup) {
            this.currentlyExpandedWindow['expandNewGroup'] = true;
            this.currentlyExpandedWindow['expandChatSearch'] = false;
        } else if (this.expandChatSearch) {
            this.currentlyExpandedWindow['expandChatSearch'] = true;
            this.currentlyExpandedWindow['expandNewGroup'] = false;
        }
        this.expandChatSearch = false;
        this.expandNewGroup = false;
    }

    showChatSearch() {
        this.currentlyExpandedWindow['expandChatSearch'] = false;
        this.expandChatSearch = true;
        if (this.expandNewGroup) {
            this.currentlyExpandedWindow['expandNewGroup'] = true;
            this.currentlyExpandedWindow['expandChatMessages'] = false;
        } else if (this.expandChatMessages) {
            this.currentlyExpandedWindow['expandChatMessages'] = true;
            this.currentlyExpandedWindow['expandNewGroup'] = false;
        }
        this.expandChatMessages = false;
        this.expandNewGroup = false;
    }

    showChatGroup() {
        this.currentlyExpandedWindow['expandNewGroup'] = false;
        this.expandNewGroup = true;
        if (this.expandChatSearch) {
            this.currentlyExpandedWindow['expandChatSearch'] = true;
            this.currentlyExpandedWindow['expandChatMessages'] = false;
        } else if (this.expandChatMessages) {
            this.currentlyExpandedWindow['expandChatMessages'] = true;
            this.currentlyExpandedWindow['expandChatSearch'] = false;
        }
        this.expandChatMessages = false;
        this.expandChatSearch = false;
    }

    scrollMessageDivBottom() {
        setTimeout(() => {
            let msgsDiv = document.getElementsByClassName("messages_list_row_chat_history")[0];
            msgsDiv.scrollTop = msgsDiv.scrollHeight;
            this.flagMsgHistory = true;
        }, 50);
    }

    roleLabel(roleName: any) {
        return this.roleLabels[roleName];
    }

    resendInvitation(activeChat: any) {
        let reqData = {};
        if (activeChat.resend_invitation_plan_id) {
            reqData['message']= activeChat['resend_invitation_message'];
            reqData['entry_id']= activeChat['resend_invitation_plan_id'];
        }
        this.apiSubscriptions.push(this._chatService.resendInvitaion(this.activeChat.id, reqData)
            .subscribe((res: any) => {
                this._mdlSnackbarService.showSnackbar('INVITATION_RESENT', 'success')
            }, error => {
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            })
        );
    }

    autosize(){
        var textarea = document.querySelector('textarea');
        // var msgSection = document.getElementById('messages_list_row_chat_history');
        setTimeout(function(){
            textarea.style.cssText = 'height:40px;';
        //   msgSection.style.height = '405px';
          // for box-sizing other than "content-box" use:
          // textarea.style.cssText = '-moz-box-sizing:content-box';
            if (textarea.scrollHeight > 40) {
                textarea.style.cssText = 'height:' + textarea.scrollHeight + 'px';
            }
        //   let newMsgSectionHeight = parseInt(msgSection.style.height) - textarea.scrollHeight + 18;
        //   if (parseInt(msgSection.style.height) >= 281) {
        //     msgSection.style.height = '' + newMsgSectionHeight + 'px';
        //   } else {
        //     msgSection.style.height = '280px';
        //   }
        //   msgSection.scrollTop = msgSection.scrollHeight;
        },0);
    }

    ngOnDestroy() {
        // unsubscribe all subscriptions
        this.apiSubscriptions.forEach(subscription => subscription?.unsubscribe());
        this.chatPeopleSubscription?.unsubscribe();
        this.addMemberToGroupSubscription?.unsubscribe();
        this.addPhoneToGroupSubscription?.unsubscribe();
        this.removePhoneSubscription?.unsubscribe();
        this.removeMemberSubscription?.unsubscribe();
        this.createGroupSubscription?.unsubscribe();
        this.startNewChatSubscription?.unsubscribe();
        this.searchPeopleSubscription?.unsubscribe();
        this.getMessagePeopleSubscription?.unsubscribe();
        this.chatRoomSubscription?.unsubscribe();
    }
}